import apiFetch from '../apiFetch'

export default function (token, saleId) {
  return apiFetch({ endPoint: `Dossier/Sale/${saleId}/CanConfigureCampaign`, method: 'GET', token: token })
}
